/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import { useEffect } from "react";
import { useSpinnerStore } from "../../../store/useSpinnerStore";

// @components
import ContactUsCard from "../../../components/molecules/ContactUsCard";

const ContactUser = () => {
    const { openSpinner } = useSpinnerStore();

    useEffect(() => {
        openSpinner(true);
        setTimeout(() => {
            openSpinner(false);
        }, 1000);
    }, [])

    return (
        <div className='w-full h-[70vh] flex flex-col items-center p-4'>
            <div className="flex items-center space-x-3 rtl:space-x-reverse" >
                <h5 className="pl-6 xl:pl-4 text-textBrand text-center font-serif dark:text-dark-bgBrand text-[22px] xl:text-3xl font-bold leading-10 tracking-[5.50px] self-center whitespace-nowrap">
                    XERVIX
                </h5>
            </div >

            <section className='w-full flex flex-col xl:flex-row justify-center items-center gap-[20px] mt-[50px]'>
                <ContactUsCard />

                <div className="w-full">
                    <img
                        src="/assets/icons/cloudCohete.svg"
                        alt="Twiter logo"
                        className="w-auto h-auto"
                    />
                </div>

            </section>
        </div>
    )
}

export default ContactUser